var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:_vm.styleClass ?? 'mr-4 float-right',attrs:{"color":_vm.color ?? 'grey lighten-4',"small":"","elevation":"1","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }